import { noTokenAxios as axios } from '@/api'

export interface BannerProps {
  title: string;
  content: string;
  image: string;
  image_background_color: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  click_link: string;
}

export const getBanners = () => {
  return axios.get('/api/popup/').then((response): BannerProps[] => response.data)
}
